export const END = 5.0;
export const HOLD = 1.0;

export const clamp01 = (x) => Math.max(0, Math.min(1, x));
export const prog = (t, start, dur) => clamp01((t - start) / dur);
export const lerp = (a, b, p) => a + (b - a) * p;
export const easeOutCubic = (x) => 1 - Math.pow(1 - x, 3);
export const easeInOutCubic = (x) =>
  x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
export const easeOutBack = (x, c1 = 1.70158) => {
  const c3 = c1 + 1;
  return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
};
